import PlanItem from './PlanItem'

const CurrentPlanSection = ({
  currentPlan,
  ufValue,
  onChangePlanClick,
  onCancelPlanClick,
  onResumePlanClick
}) => (
  <div className='lg:col-span-1'>
    {currentPlan ? (
      <PlanItem
        plan={currentPlan}
        isSelected={true}
        isSelectedForUpdate={false}
        onSelect={null}
        ufValue={ufValue}
        onChangePlanClick={onChangePlanClick}
        onCancelPlanClick={onCancelPlanClick}
        onResumePlanClick={onResumePlanClick}
      />
    ) : (
      <div className='relative flex h-full flex-col overflow-hidden rounded-[28px] border border-green-500 bg-gradient-to-b from-green-50 via-white to-white shadow-lg'>
        <div className='absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-green-500 via-green-400 to-green-500' />

        <div className='flex h-full flex-col p-6 sm:p-7'>
          <div className='flex items-start justify-between gap-3'>
            <span className='inline-flex items-center rounded-full border border-gray-200 bg-white px-3 py-1 text-[11px] font-sans font-semibold uppercase tracking-[0.16em] text-gray-500'>
              Estado
            </span>
            <span className='inline-flex items-center rounded-full bg-green-500 px-3 py-1 text-[11px] font-sans font-semibold uppercase tracking-[0.16em] text-white'>
              Trial
            </span>
          </div>

          <div className='mt-2'>
            <h3 className='text-2xl font-sans font-semibold tracking-tight text-gray-900 sm:text-[1.9rem]'>
              Free Trial
            </h3>
            <p className='mt-2 min-h-[48px] text-sm font-sans leading-6 text-gray-600'>
              Activa tu plan y sigue usando TryLuca sin interrupciones.
            </p>
          </div>

          <div className='mt-2 rounded-[24px] border border-green-100 bg-white/95 p-5'>
            <p className='text-[11px] font-sans font-semibold uppercase tracking-[0.18em]'>
              Siguiente paso
            </p>
            {/*<p className='mt-2 text-lg font-sans font-semibold text-gray-900'>
              Aprovecha todas las funcionalidades disponibles
            </p>*/}
            <p className='mt-2 text-sm font-sans text-gray-500'>
              Al finalizar tu prueba, necesitarás un plan activo para seguir accediendo a tus reportes y automatizaciones. Toma menos de 1 minuto.
            </p>
          </div>

          <div className='mt-6'>
            <button
              type='button'
              onClick={onChangePlanClick}
              className='w-full rounded-full bg-accent2 px-4 py-3 text-sm font-medium text-white transition-opacity hover:bg-opacity-90'
            >
              Contratar plan
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)

export default CurrentPlanSection
